import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 配置 ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 全局特效
import animated from 'animate.css'
import plugins from './plugins' // plugins

Vue.use(animated)
Vue.use(plugins)

// 全局组件
import tzForm from '@/components/tz-form/Index'
import tzTable from '@/components/tz-table/Index'
import tzCard from '@/components/tz-card/Index'
// 图片上传组件
import ImageUpload from '@/components/ImageUpload'
Vue.use(function () {
  Vue.component('tzForm', tzForm)
  Vue.component('tzTable', tzTable)
  Vue.component('tzCard', tzCard)
  Vue.component('ImageUpload', ImageUpload)
})

// 全局混入
import '@/utils/mixins'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
